// Icons
import autoLoan from 'assets/images/liability/auto_loan.svg';
import houseLoan from 'assets/images/liability/house_loan.svg';
import personalLoan from 'assets/images/liability/personal_loan.svg';
import studentLoan from 'assets/images/liability/student_loans.svg';

// Constant
import { AUTO, MORTGAGE, HELOC, STUDENT, PERSONAL } from 'shared/constants';

const LOAN_ICON_AND_HEADING_MAPPING = {
	[MORTGAGE]: {
		currentLoanHeading: 'Home Loan',
		currentLoanIcon: houseLoan
	},
	[HELOC]: {
		currentLoanHeading: 'Home Loan (HELOC)',
		currentLoanIcon: houseLoan
	},
	[AUTO]: {
		currentLoanHeading: 'Auto Loan',
		currentLoanIcon: autoLoan
	},
	[STUDENT]: {
		currentLoanHeading: 'Student Loan',
		currentLoanIcon: studentLoan
	},
	[PERSONAL]: {
		currentLoanHeading: 'Personal Loan',
		currentLoanIcon: personalLoan
	}
};

export default LOAN_ICON_AND_HEADING_MAPPING;
